// extracted by mini-css-extract-plugin
export default {"tappable":"InterviewbitTestSelect_tappable__sOPaV","selected":"InterviewbitTestSelect_selected__tFei-"};